import Vue from "vue";
import VueI18n from "vue-i18n";

let locale = "ja",
  message = {}; // default: "ja"
const language = window.navigator.language;
if (language) {
  const lang = language.toLowerCase().split("-");
  switch (lang[0]) {
    case "en": // 英語
      locale = "en";
      message[locale] = require("../assets/i18n/en.json");
      break;
  }
}

// let locale = "ja",
//   message = {}; // default: "ja"
// const language = window.navigator.language;
// if (language) {
//   const lang = language.toLowerCase().split("-");
//   switch (lang[0]) {
//     case "en": // 英語
//       locale = "en";
//       message = require("../assets/i18n/en.json");
//       break;
//   }
// }

message[locale] = require(`../assets/i18n/${locale}.json`);
// message[locale] = require(`../assets/i18n/${locale}.json`);

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale,
  messages: message, // 必要な言語ファイルのみ設定する
});

// Vue.use(VueI18n);

// export const i18n = new VueI18n({
//   locale,
//   messages: message, // 必要な言語ファイルのみ設定する
// });
